// AUTO-MIGRATED national copy shared by every market landing page (MS-172).
// These sections are identical across all markets — only the city name, hero
// photo, and per-city paragraph (in ./marketContent) vary.
import { MetricsSectionContent, TestimonialsSectionContent } from '../app-types'
import { SectionContentCardListProps } from '../components/SectionContentCardList'
import { SectionContentIconBlocksProps } from '../components/SectionContentIconBlocks'
import { SectionContentLogoCarouselProps } from '../components/SectionContentLogoCarousel'

export const MARKET_METRICS: MetricsSectionContent = {
  id: 'market-metrics',
  heading: 'By the Numbers',
  metrics: [
    {
      id: 'metric-0',
      heading: 'Hours Worked',
      format: 'compact',
      value: 2310000,
    },
    {
      id: 'metric-1',
      heading: 'Businesses Using Qwick',
      format: 'compact',
      value: 5087,
    },
    {
      id: 'metric-2',
      heading: 'Pros Filling Shifts',
      format: 'compact',
      value: 221537,
    },
  ],
}

export const MARKET_SKILL_CARDS: SectionContentCardListProps = {
  heading: 'We help professionals find shifts that match their skills.',
  cards: [
    {
      id: 'card-0',
      title: 'Front of House',
      listItems: [
        'FOH Support',
        'Restaurant Server',
        'Barback',
        'Busser',
        'Food Assembler',
        'Food Runner',
      ],
      icon: {
        publicId: 'icons/values-innovation',
        alt: '',
      },
    },
    {
      id: 'card-1',
      title: 'Back of House',
      listItems: [
        'Dishwasher',
        'Line Cook',
        'Prep Cook',
        'Food Assembler',
        'General Labor',
        'General Cleaning',
      ],
      icon: {
        publicId: 'icons/icon-1',
        alt: '',
      },
    },
    {
      id: 'card-2',
      title: 'Catering + Events',
      listItems: [
        'Event Chef',
        'Banquet Cook',
        'Banquet Server',
        'Banquet Captain',
        'Concession Worker',
        'Event Help',
      ],
      icon: {
        publicId: 'icons/icn-cateringevents',
        alt: '',
      },
    },
  ],
}

export const MARKET_TESTIMONIALS: TestimonialsSectionContent = {
  id: 'market-testimonials',
  title: 'What our regulars have to say about Qwick',
  testimonials: [
    {
      id: 't-0',
      personName: 'Candace',
      persona: 'business',
      subcopy: 'Director, Chick-fil-A',
      quotation: {
        quotation:
          'Qwick has definitely helped ease some of the strain of being short-staffed. All of the pros we’ve had in store so far have been highly rated by our staff.',
      },
    },
    {
      id: 't-1',
      personName: 'Josh',
      persona: 'business',
      subcopy: 'Director, Pies and Pints',
      quotation: {
        quotation:
          'Qwick has been a blessing. It’s able to seamlessly connect our locations with people looking to work both conventional and unconventional hours and shifts.',
      },
    },
    {
      id: 't-2',
      personName: 'Troy',
      persona: 'business',
      subcopy: 'Executive Chef, JB Duke Hotel',
      quotation: {
        quotation:
          'Qwick has offered me an added level of confidence in scheduling and hiring for our hotel properties while advancing the staffing industry as a whole.',
      },
    },
  ],
}

export const STATE_ICON_BLOCKS: SectionContentIconBlocksProps = {
  heading:
    'We’ve connected thousands of hospitality professionals with businesses across the country to complete millions of shifts. Our process is simple:',
  iconBlocks: [
    {
      id: 'ib-0',
      heading: 'Businesses post available shifts.',
      description:
        'Shifts can be one-time shifts, seasonal, or temp-to-hire needs.',
      icon: {
        publicId: 'icons/icon-1',
        alt: '',
      },
    },
    {
      id: 'ib-1',
      heading: 'Pros apply through the app.',
      description:
        'Pros see available shifts and apply. Businesses get to select applicants.',
      icon: {
        publicId: 'icons/icon-pro-applying',
        alt: '',
      },
    },
    {
      id: 'ib-2',
      heading: 'Shifts get filled, pros get paid.',
      description:
        'Pros get paid through the app via Stripe after a shift is completed.',
      icon: {
        publicId: 'icons/icon-stripe',
        alt: '',
      },
    },
  ],
}

export const STATE_LOGO_CAROUSEL: SectionContentLogoCarouselProps = {
  heading:
    'Join the thousands of businesses nationwide that trust and use our platform.',
  logos: [
    {
      companyName: 'Mellow Mushroom',
      image: {
        publicId: 'logos/logo-restaurant-mellow-mushroom',
        alt: 'Mellow Mushroom',
      },
    },
    {
      companyName: 'Georgian Terrace',
      image: {
        publicId: 'logos/logo-restaurant-georgian-terrace',
        alt: 'Georgian Terrace',
      },
    },
    {
      companyName: 'IPIC',
      image: {
        publicId: 'logos/logo-catering-fsg-ipic',
        alt: 'IPIC',
      },
    },
    {
      companyName: "Rosemary's Catering",
      image: {
        publicId: 'logos/logo-catering-rosemarys-catering',
        alt: "Rosemary's Catering",
      },
    },
    {
      companyName: 'Taco Boy',
      image: {
        publicId: 'logos/logo-restaurant-tacoboy',
        alt: 'Taco Boy',
      },
    },
    {
      companyName: 'Marriott',
      image: {
        publicId: 'logos/logo-hotel-marriot',
        alt: 'Marriott',
      },
    },
    {
      companyName: 'Aramark',
      image: {
        publicId: 'logos/logo-catering-fsg-aramark',
        alt: 'Aramark',
      },
    },
    {
      companyName: 'ooh events',
      image: {
        publicId: 'logos/logo-catering-ooh-events',
        alt: 'ooh events',
      },
    },
    {
      companyName: "Marlow's Tavern",
      image: {
        publicId: 'logos/logo-restaurant-marlows',
        alt: "Marlow's Tavern",
      },
    },
    {
      companyName: 'Hotel Hyatt',
      image: {
        publicId: 'logos/logo-hotel-hyatt',
        alt: 'Hotel Hyatt',
      },
    },
    {
      companyName: 'Oak View Group',
      image: {
        publicId: 'logos/logo-catering-fsg-oak-view-group',
        alt: 'Oak View Group',
      },
    },
    {
      companyName: 'Serena Pastificio',
      image: {
        publicId: 'logos/logo-restaurant-serena',
        alt: 'Serena Pastificio',
      },
    },
    {
      companyName: 'Holiday Inn',
      image: {
        publicId: 'logos/logo-hotel-holiday-inn',
        alt: 'Holiday Inn',
      },
    },
    {
      companyName: 'Snyder Events',
      image: {
        publicId: 'logos/logo-catering-snyder-event',
        alt: 'Snyder Events',
      },
    },
    {
      companyName: 'Southern',
      image: {
        publicId: 'logos/logo-catering-fsg-southern',
        alt: 'Southern',
      },
    },
    {
      companyName: 'Chick Fil A',
      image: {
        publicId: 'logos/logo-restaurant-chick-fil-a',
        alt: 'Chick Fil A',
      },
    },
    {
      companyName: 'Hilton',
      image: {
        publicId: 'logos/logo-hotel-hilton',
        alt: 'Hilton',
      },
    },
    {
      companyName: 'PGA Ocean Course',
      image: {
        publicId: 'logos/logo-catering-event-pga',
        alt: 'PGA Ocean Course',
      },
    },
    {
      companyName: 'Duvall Catering',
      image: {
        publicId: 'logos/logo-catering-duvall',
        alt: 'Duvall Catering',
      },
    },
    {
      companyName: 'Halls',
      image: {
        publicId: 'logos/logo-restaurant-halls',
        alt: 'Halls',
      },
    },
    {
      companyName: 'Wild Dunes',
      image: {
        publicId: 'logos/logo-hotel-wild-dunes',
        alt: 'Wild Dunes',
      },
    },
    {
      companyName: 'Credit One Stadium',
      image: {
        publicId: 'logos/logo-catering-fsg-creditone',
        alt: 'Credit One Stadium',
      },
    },
    {
      companyName: 'The 404',
      image: {
        publicId: 'logos/logo-restaurant-404',
        alt: 'The 404',
      },
    },
    {
      companyName: 'Hotel Belmond Charleston Place',
      image: {
        publicId: 'logos/logo-hotel-belmond-charleston-place',
        alt: 'Hotel Belmond Charleston Place',
      },
    },
    {
      companyName: 'Customer Logo > Moody Center',
      image: {
        publicId: 'logos/logo-catering-event-moody-center',
        alt: 'Customer Logo > Moody Center',
      },
    },
    {
      companyName: 'La Pera',
      image: {
        publicId: 'logos/logo-catering-la-pera',
        alt: 'La Pera',
      },
    },
    {
      companyName: 'Kiawah Island Resort',
      image: {
        publicId: 'logos/logo-hotel-kiawah-island-resort',
        alt: 'Kiawah Island Resort',
      },
    },
    {
      companyName: 'Argosy',
      image: {
        publicId: 'logos/logo-restaurant-argosy',
        alt: 'Argosy',
      },
    },
    {
      companyName: 'Curated Events Charleston',
      image: {
        publicId: 'logos/logo-catering-curated-events-charleston',
        alt: 'Curated Events Charleston',
      },
    },
    {
      companyName: 'Honeybaked Ham',
      image: {
        publicId: 'logos/logo-restaurant-honeybaked-ham',
        alt: 'Honeybaked Ham',
      },
    },
    {
      companyName: 'Iberian Pig',
      image: {
        publicId: 'logos/logo-restaurant-iberian-pig',
        alt: 'Iberian Pig',
      },
    },
    {
      companyName: 'Customer Logo > Make Ready',
      image: {
        publicId: 'logos/logo-hotel-make-ready',
        alt: 'Customer Logo > Make Ready',
      },
    },
    {
      companyName: 'FIG',
      image: {
        publicId: 'logos/logo-restaurant-fig',
        alt: 'FIG',
      },
    },
    {
      companyName: 'CMA Fest',
      image: {
        publicId: 'logos/logo-catering-cma-fest',
        alt: 'CMA Fest',
      },
    },
    {
      companyName: 'Austin Country Club',
      image: {
        publicId: 'logos/logo-catering-event-austin-country-club',
        alt: 'Austin Country Club',
      },
    },
    {
      companyName: 'Charleston Metro Credit Union',
      image: {
        publicId: 'logos/logo-catering-event-charleston-metro',
        alt: 'Charleston Metro Credit Union',
      },
    },
    {
      companyName: 'The Pines at Davidson',
      image: {
        publicId: 'logos/logo-catering-the-pines',
        alt: 'The Pines at Davidson',
      },
    },
  ],
}
